import axios from "axios";
import config from "./../config/config-secret.json";
import store from "./../app/store";
import { showModal } from "./../actions/assessment";

const API_ERROR_MSG = "An error occurred. Please contact your administrator.";

export const SaveUserStateToServerHelper = (state) => {
  window.localStorage.setItem(state.key, JSON.stringify(state));

  const { tester_id, ...last_session_info } = state;

  axios
    .post(config.API_URL + "/administer_test/update_tester_session_info/", {
      tester_id: tester_id,
      last_session_info: JSON.stringify(last_session_info),
    })
    .then((res) => {
      // console.log(res.data.success);
      // if (res.data.success === false) {
      //   const msg = res.data.message || API_ERROR_MSG;
      //   store.dispatch(showModal(msg, true));
      //   return;
      // }
      document.querySelector("#initloader").style.display = "none";
    })
    .catch((error) => {
      document.querySelector("#initloader").style.display = "none";
      // const msg = error?.response?.data?.message || API_ERROR_MSG;
      // store.dispatch(showModal(msg, true));
      console.log(error);
    });
};

export const ExamCompletedHelper = async (state) => {
  const {
    tester_id,
    answers,
    time_consume_per_question,
    demographics,
    sport_demographics,
    typing_test_result,
    data_entry_test_result,
    open_questions,
    open_questions_answers,
    cheat_count,
  } = state;

  // document.querySelector("#savingLoader").style.display = "";
  document.querySelector("#close").style.display = "none";
  document.querySelector("#processing").style.display = "";
  // document.querySelector("#comp_close_text").style.display = "none";
  document.querySelector("#exam_completion_processing_text").style.display = "";
  await axios
    .post(config.API_URL + "/administer_test/completed/", {
      tester_id: tester_id,
      question_choices_ids: answers,
      time_consume_per_question: time_consume_per_question,
      demographics: demographics,
      sport_demographics: sport_demographics,
      typing_test_result: typing_test_result,
      data_entry_test_result: data_entry_test_result,
      open_questions: open_questions,
      open_questions_answers: open_questions_answers,
      cheat_count: cheat_count,
    })
    .then((res) => {
      window.localStorage.removeItem(state.key);
      window.localStorage.removeItem(state.key + "_cheat_count");
      // const response = res.data;
      // document.querySelector("#savingLoader").style.display = "none";
      document.querySelector("#close").style.display = "";
      document.querySelector("#processing").style.display = "none";
      // document.querySelector("#comp_close_text").style.display = "";
      document.querySelector("#exam_completion_processing_text").style.display =
        "none";
    })
    .catch((error) => {
      document.querySelector("#savingLoader").style.display = "none";
      console.log(error);
      // alert("Something went wrong. Please contact administrator!");
    });
};

export const SetupBeforeUnloadListener = (state) => {
  console.log("SetupBeforeUnloadListener called");
  window.addEventListener("beforeunload", (ev) => {
    ev.preventDefault();
    console.dir(state);
    SaveUserStateToServerHelper(state);
  });
};

export const CandidateConfirmationEmail = (state) => {
  const { tester_id } = state;

  return axios
    .post(config.API_URL + "/administer_test/submitted_confirmation_email/", {
      tester_id: tester_id,
    })
    .then((res) => {
      console.log("CandidateConfirmationEmail response: ", res.data);
      document.querySelector("#initloader").style.display = "none";
    })
    .catch((error) => {
      document.querySelector("#initloader").style.display = "none";
      console.log(error);
    });
};
